/**
 * This file was auto-generated
 * Do not edit manually
 */

import { createContext, useContext, useState, useMemo, type ReactNode, useEffect } from 'react'

import { locales } from './i18n'
import type { Translations, Locales } from './i18n-types'

interface I18nContextValue {
	locale: Locales
	L: Translations
	setLocale: (locale: Locales) => void
}

const I18nContext = createContext<I18nContextValue | null>(null)

export interface I18nProviderProps {
	children: ReactNode
	initialLocale: Locales
	onLocaleChanged?: (locale: Locales) => void
}

export function I18nProvider({ children, initialLocale, onLocaleChanged }: I18nProviderProps) {
	const [locale, setLocale] = useState<Locales>(initialLocale)

	useEffect(() => {
		if (onLocaleChanged) {
			onLocaleChanged(locale)
		}
	}, [locale, onLocaleChanged])

	const value = useMemo(
		() => ({
			locale,
			L: locales[locale],
			setLocale
		}),
		[locale]
	)

	return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>
}

export function useI18n(): I18nContextValue {
	const context = useContext(I18nContext)
	if (!context) {
		throw new Error('useI18n must be used within I18nProvider')
	}
	return context
}

export function useTranslations(): Translations {
	return useI18n().L
}
